import * as React from 'react';

function useDebouncedEffect(
  callback: Function,
  dependencies: Array<any>,
  debounceBy: number = 100
) {
  React.useEffect(() => {
    const timeoutId = window.setTimeout(callback, debounceBy);

    return () => {
      window.clearTimeout(timeoutId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
}

export default useDebouncedEffect;
